"use client";
import { useEffect, useState } from "react";

export type SiteRegion = "eu" | "us" | "au";

export function getRegionFromHostname(hostname: string): SiteRegion {
  if (hostname.startsWith("eu.")) return "eu";
  if (hostname.startsWith("au.")) return "au";
  return "us";
}

export function useCurrentRegion(): SiteRegion {
  // Default to "us" so region-gated content renders by default (no flash for
  // the majority); only EU/AU adjust after mount. Hostname must be read in an
  // effect — reading `window` during render would break SSR / hydration.
  const [region, setRegion] = useState<SiteRegion>("us");
  useEffect(() => {
    setRegion(getRegionFromHostname(window.location.hostname));
  }, []);
  return region;
}
